/**
 * 路由名稱
 */
export enum RouterName {
  /** 首頁 */
  HOME = 'home',
  /** 差旅經理人 - 購票及行程管理 - 立即購票 */
  TRAVEL_MANAGER_BOOK_FLIGHT = 'travel-manager-book-flight',
  /** 差旅人 - 購票及行程管理 - 立即購票 */
  TRAVELER_BOOK_FLIGHT = 'traveler-book-flight',
  /** 企業綁定登入會員 */
  COMPANY_EMPLOYEE = 'company-employee',
  /** 企業綁定 */
  COMPANY_EMPLOYEE_BIND = 'company-employee-bind',
  /** 更換企業綁定 */
  COMPANY_EMPLOYEE_BIND_CHANGE = 'company-employee-bind-change',
  /** 企業綁定成功頁面 */
  COMPANY_EMPLOYEE_BIND_SUCCESS = 'company-employee-bind-success',
  /** 忘記/更改密碼 */
  RESET_LATCH_KEY = 'reset-latch-key',
  /** 忘記/更改密碼 - 成功頁面 */
  RESET_LATCH_KEY_SUCCESS = 'reset-latch-key-success',
  /** 加入我們 */
  JOIN_US = 'join-us',
  /** 加入我們 - 入會規則與條款 */
  JOIN_US_TERMS = 'join-us-terms',
  /** 加入我們 - 申請入會 - 基本資料 */
  JOIN_US_APPLICATION = 'join-us-application',
  /** 加入我們 - 申請入會 - 成功頁面 */
  JOIN_US_APPLICATION_SUCCESS = 'join-us-application-success',
  /** 加入我們 - 使用企業辨識碼 */
  JOIN_US_CORPORATE_IDENTIFIER = 'join-us-corporate-identifier',
  /** 加入我們 - 使用企業辨識碼- 寄送邀請信 */
  JOIN_US_CORPORATE_IDENTIFIER_INVITATION = 'join-us-corporate-identifier-invitation',
  /** 加入我們 - 使用企業辨識碼 - 成功頁面 */
  JOIN_US_CORPORATE_IDENTIFIER_SUCCESS = 'join-us-corporate-identifier-success',
  /** 最新消息 */
  NEWS = 'news',
  /** 最新消息 - 內容 */
  NEWS_DETAIL = 'news-detail',
  /** FAQ */
  FAQ = 'faq',
  /** 方案介紹 */
  BIZFAM_INTRODUCTION = 'bizfam-introduction',
  /** MICE */
  MICE = 'mice',
  /** UATP */
  UATP = 'uatp',
  /** 我的帳號 */
  MY_ACCOUNT = 'my-account',
  /** 會員尊享 */
  EXCLUSIVE_OFFER = 'exclusive-offer',
  /** 會員尊享 - 內容 */
  EXCLUSIVE_OFFER_DETAIL = 'exclusive-offer-detail',
  /** Bizfam 獨享 - 列表 */
  OFFERS = 'offers',
  /** Bizfam 獨享 - 詳細頁 */
  OFFERS_DETAIL = 'offers-detail',
  /** 差旅經理人 - 員工名單管理 - 員工名單 */
  STAFF_MANAGEMENT = 'staff-management',
  /** 差旅經理人 - 員工名單管理 - 寄送邀請信 */
  STAFF_INVITATION = 'staff-invitation',
  /** 差旅經理人 - 員工名單管理 - 寄送邀請信紀錄 */
  STAFF_INVITATION_RECORD = 'staff-invitation-record',
  /** 差旅經理人 - 禮遇兌換管理 - 點數明細查詢 */
  HOSPITALITY_EXCHANGE_POINTS = 'hospitality-exchange-points',
  /** 差旅經理人 - 禮遇兌換管理 - 禮遇兌換 */
  HOSPITALITY_EXCHANGE_LIST = 'hospitality-exchange-list',
  /** 差旅經理人 - 禮遇兌換管理 - 禮遇兌換詳細頁面 */
  HOSPITALITY_EXCHANGE_DETAIL = 'hospitality-exchange-detail',
  /** 差旅經理人 - 禮遇兌換管理 - 指派禮遇 */
  HOSPITALITY_ASSIGNMENT = 'hospitality-assignment',
  /** 差旅經理人 - 禮遇兌換管理 - 代辦禮遇安排 - 清單 */
  HOSPITALITY_AGENT_ARRANGEMENT_LIST = 'hospitality-agent-arrangement-list',
  /** 差旅經理人 - 禮遇兌換管理 - 代辦禮遇安排 */
  HOSPITALITY_AGENT_ARRANGEMENT = 'hospitality-agent-arrangement',
  /** 差旅經理人 - 禮遇兌換管理 - 代辦禮遇安排 - 詳細資訊 */
  HOSPITALITY_AGENT_ARRANGEMENT_DETAIL = 'hospitality-agent-arrangement-detail',
  /** 差旅經理人 - 差旅金額統計 - 本次合約期間開票總金額 */
  BUSINESS_TRIP_CONTRACT_AMOUNT = 'contract-amount',
  /** 差旅經理人 - 差旅金額統計 - 其他 (歷史) 區間查詢 */
  BUSINESS_TRIP_HISTORY_INTERVAL = 'history-interval',
  /** 差旅經理人 - 差旅金額統計 -各檻次禮遇介紹 */
  BUSINESS_TRIP_CASE_INTRODUCTION = 'case-introduction',
  /** 差旅經理人 - 購物車 - index */
  CART = 'cart',
  /** 差旅人 - 我的行程 - 列表 */
  JOURNEY_HOSPITALITY_ARRANGEMENT_LIST = 'journey-hospitality-arrangement-list',
  /** 差旅人 - 我的行程 - 內容 */
  JOURNEY_HOSPITALITY_ARRANGEMENT_DETAIL = 'journey-hospitality-arrangement-detail',
  /** 差旅人 - 我的禮遇清單 - 列表 */
  TREATMENT_LIST = 'treatment-list',
  /** 差旅人 - 我的禮遇清單 - 歷史紀錄 */
  TREATMENT_HISTORY = 'treatment-history',
  /** 網站導覽 */
  SITEMAP = 'sitemap',
  /** 邀請信 */
  INVITE_MAIL = 'invite-mail',
  /** 邀請信 - 錯誤 */
  INVITE_ERROR = 'invite-error',
  /** 信件預覽 */
  MAIL_PREVIEW = 'mail-preview',
  /** 404 - 找不到頁面 */
  ERROR = 'error',
  /** 登入跳轉頁 */
  LOGIN_REDIRECT = 'login-redirect'
}
